/*
==========================================================
IMPORTS
==========================================================
*/

import LoginPage from "./platform/auth/LoginPage";

/*
==========================================================
PAGE
==========================================================
*/

export default function Login() {

  return <LoginPage />;

}